const selectors = {
	vidyardContainer: '.ThirdPartyVideo-vidyard-container',
};

///////////////////////////////
export const getJwt = async uuid => {
	return new Promise((resolve, reject) => {
		if (!uuid) {
			reject(new Error('No uuid provided'));
		} else {
			if (uuid.indexOf('//') < 0) {
				//this means we weren't provided an internalId and
				//therefore can't create a JWT. This isn't an error,
				//just a situration that the invoker needs to deal with
				resolve({ uuid });
			} else {
				var uuidParts = uuid.split('//');
				var internalId = uuidParts[0];
				uuid = uuidParts[1];

				var xhr = $.post(
					'/alt/apps/fshr/shared/vidyardJwt',
					$.extend({ player_uuid: uuid, internalId: internalId }, {})
				);
				xhr.then(function (data, statusText, error) {
					statusText === 'success' ? resolve({ jwt: data.jwt, uuid }) : reject(error);
				});
			}
		}
	});
};

///////////////////////////////
const renderPlayers = ({ api: vidyardApi }, container = window.document) => {
	const $container = $(container);
	$container.find(selectors.vidyardContainer).each(async function () {
		//get the JWT for each player and inject the script
		const $container = $(this);
		let uuid = $container.data('uuid');
		if (uuid) {
			const jwtResult = await getJwt(uuid);
			const { jwt } = jwtResult;
			uuid = jwtResult.uuid;

			vidyardApi.renderPlayer({ uuid, jwt, container: $container[0] });
		}
	});

	//handle GDPR
	window.FS.GDPR.getSavedConsent(groups => {
		vidyardApi.GDPR.consent(groups['performance']);
	});
	//setup listener for change in consent
	window.FS.GDPR.onConsentChange(groups => {
		vidyardApi.GDPR.consent(groups['performance']);
	});
};

///////////////////////////////
const removePlayers = (container = window.document) => {
	const $container = $(container);

	$container.find(selectors.vidyardContainer).each(function () {
		const $playerContainer = $(this);

		//remove whatever elements there might be
		$playerContainer.html(
			'<div><p>Video player is disabled. To enable, please enable Performance Cookies via the Cookie Preferences link in the footer and reload the page.</p></div>'
		);
	});
};

///////////////////////////////
export default function initPlayers(container = window.document) {
	//only try to initialize on pages that actually have a Vidyard video
	if ($(selectors.vidyardContainer).length) {
		//if permission group X exists in OnetrustActiveGroups then proceed
		window.FS.GDPR.loadScript(
			{ script: 'https://play.vidyard.com/embed/v4.js', tagOptions: { async: true } },
			'performance',
			//runs if script is added to the page
			() => {
				if (window.vidyardEmbed) {
					renderPlayers(window.vidyardEmbed, container);
				} else {
					window.onVidyardAPI = renderPlayers;
				}
			},
			//runs if script isn't added to the page
			() => {
				removePlayers();
			}
		);
	}
}
